import React from "react";
import SWBTable from "./SWBTable";
const SectionWiseBlockMaster = ({ data }) => {
  return (
    <div>
      <h5 className="bg-dark text-white p-1">Section Wise Block </h5>
      <SWBTable data={data} />
    </div>
  );
};
export default SectionWiseBlockMaster;
